import { ImageLoaderCSSStyleImpl } from '../../../../toolkit/imageloader/imageloadercss';

export class BannerCardMobileImageLoaderCSSStyleImpl extends ImageLoaderCSSStyleImpl
{
    getImgCSSStyle(): object 
    {
        return {
            // objectFit: 'cover', 
            width: '100%', 
            height: '185px',
            borderRadius:"10px"
            // borderRadius: "0px",
            // background: 'linear-gradient(225deg, #0030B7 0%, #4269D4 51.26%, #000000 100%)',
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/banner/bannercard/bannercardmobileimageloader .tsx